var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import getTranslation from "../../../../strings/getTranslations";
import { useEditProfileContext } from "../../../../context/editProfileContext";
import CardHeader from "../../../atoms/CardHeader";
import CustomMessageBox from "../../../atoms/CustomMessageBox";
import ProfileRow from "../../../molecules/ProfileRow";
import { RowInput } from "../../../subcomponents";
var HeaderSection = function () {
    var t = getTranslation().t;
    var _a = useEditProfileContext(), pageApiError = _a.pageApiError, phoneRequiredError = _a.phoneRequiredError;
    return (_jsxs(_Fragment, { children: [_jsx(ProfileRow, { children: _jsx(RowInput, { children: _jsx(CardHeader, {}) }) }), _jsxs(ProfileRow, __assign({ title: " " }, { children: [pageApiError && (_jsx(CustomMessageBox, { message: t(pageApiError) })), phoneRequiredError && (_jsx(CustomMessageBox, { message: t("forms.errors.page.phone") }))] }))] }));
};
export default HeaderSection;
